import * as gtag from "../../utils/gtag";

export const sendClickLogoMenuEvent = () => {
    gtag.overallEvent('click_logo', 'unknown');
}

export const sendClickHowToMenuEvent = () => {
    gtag.overallEvent('click_howto_menu', 'unknown');
}

export const sendClickUpload = (label: string) => {
    gtag.overallEvent('click_upload', label);
}
